/**
 * Token / 用户信息持久化 · localStorage 封装
 * 启动时可调用 getStoredAuth() 恢复上一会话
 */

const TOKEN_KEY = 'poet.accessToken';
const REFRESH_KEY = 'poet.refreshToken';
const USER_KEY = 'poet.user';

export interface StoredUser {
  id: string;
  name: string;
  role: 'admin' | 'teacher' | 'student' | 'assistant';
  phone?: string | null;
  studentNo?: string | null;
  employeeNo?: string | null;
  avatarUrl?: string | null;
}

export function getAccessToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function getRefreshToken(): string | null {
  return localStorage.getItem(REFRESH_KEY);
}

export function getStoredUser(): StoredUser | null {
  const raw = localStorage.getItem(USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as StoredUser;
  } catch {
    return null;
  }
}

export function setAuth(opts: {
  accessToken: string;
  refreshToken: string;
  user: StoredUser;
}): void {
  localStorage.setItem(TOKEN_KEY, opts.accessToken);
  localStorage.setItem(REFRESH_KEY, opts.refreshToken);
  localStorage.setItem(USER_KEY, JSON.stringify(opts.user));
}

export function updateAccessToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearAuth(): void {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(REFRESH_KEY);
  localStorage.removeItem(USER_KEY);
}
